<template>
  <div class="ele-state-wrap" v-loading="loading">
    <div class="box-title">绕线温度</div>
    <div class="content">
      <div class="item">
        <div class="label">A相温度：</div>
        <div class="label bold text-abnormal" v-if="obj"></div>
      </div>
      <div class="item">
        <div class="label">B相温度：</div>
        <div class="label bold text-abnormal" v-if="obj"></div>
      </div>
      <div class="item">
        <div class="label">C相温度：</div>
        <div class="label bold text-abnormal" v-if="obj"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      loading: true
    };
  },
  watch: {
    "obj.currentStateJson":{
      handler(val,oldVal){
        if (Object.keys(val).length > 0) {
          this.loading = false;
        }
      },
      deep:true,
      immediate:true
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 10px;
}
.item {
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.item:first-child {
  padding-top: 0px;
}
.item div {
  flex: 1;
}
</style>